<script setup lang="ts">
import { ref, watch } from 'vue'
import { statusOptions } from '@/shared/constants'
import { ButtonElement, SelectElement, HeaderPanel } from '@/shared/ui'

const props = withDefaults(
  defineProps<{
    filter: Record<string, unknown>
    showState?: boolean
  }>(),
  {
    filter: () => ({ state: '' }),
    showState: true,
  },
)

const localFilter = ref<{ state?: string; [key: string]: unknown }>({ ...props.filter })

watch(
  () => props.filter,
  (val) => {
    localFilter.value = { ...val }
  },
)

const emit = defineEmits<{ apply: [filter: Record<string, unknown>] }>()

const apply = () => {
  const cleaned = Object.fromEntries(
    Object.entries(localFilter.value).map(([k, v]) => {
      const isBlank = typeof v === 'string' && v.trim() === ''
      return [k, isBlank ? undefined : v]
    }),
  )
  emit('apply', cleaned)
}
</script>

<template>
  <HeaderPanel :title="$t('forms.filter')">
    <ButtonElement @click="apply" template="apply" />
  </HeaderPanel>

  <div class="flex flex-col custom-scrollbar">
    <div class="grid grid-cols-1 gap-5">
      <SelectElement
        v-if="showState"
        :label="$t('forms.status')"
        v-model="localFilter.state"
        :options="statusOptions"
      />
      <slot :filter="localFilter" />
    </div>
  </div>
</template>
